import { Component } from '@angular/core';
import { Helper } from 'src/4services/2helper';
import { BaseComponent } from '@app/directives/base-component';

@Component({
    selector: 'c_side_modal_direction_common_component',
    templateUrl: './c_side_modal_direction_common.component.html',
    styleUrls: ['../common.scss', '../c_side_modal.component.scss'],
    standalone: false
})
export class c_side_modal_direction_common_component extends BaseComponent {

  constructor(private helper: Helper) { super(); }

  goToReport(){
    this.helper.router.navigate_to(`/reports/site-note-manager`);
  }
}
